import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import routes from '../pages-routes';
import { useEffect } from 'react';
import './special.scss';

function App() {

  useEffect(() => {
  }, [])

  return (
    <>
      <BrowserRouter>
        <Switch>
          {routes.map(({ path, component }) => (
            <Route
              exact
              key={path}
              path={path}
              component={component}
            />
          ))}
          <Redirect to={'/scan'} />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
